import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Center, Text } from '@chakra-ui/react';
import { defaultFontFamily } from '@client/theme';
import { FaArrowLeft } from 'react-icons/fa6';
export const ShoppingCartEmptyMessage = (props) => (_jsxs(Center, { flexDir: "column", height: "100%", gap: 3, children: [_jsx(Text, { fontSize: 36, children: "Your cart is empty" }), _jsxs(Button, { onClick: props.onClick, size: "sm", fontSize: 18, fontFamily: defaultFontFamily, children: [_jsx(FaArrowLeft, {}), "Keep Looking"] })] }));
